var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hablan-de-nosotros"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('clientes.slideTitle')))]),_vm._v(" "),_c('section',{staticClass:"articles-relacionated"},[_c('div',{staticClass:"all-entries"},[_c('last-noticias',{attrs:{"success":1}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55309bf1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/clientes/hablan-de-nosotros.vue
// module id = null
// module chunks = 